<template>
  <div class="section7 f-p-section">
    <div class="title-box">
      <div
        class="img"
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-delay="0"
      >
        <img
          class="tree"
          src="./s7/tree.png"
          alt=""
          srcset=""
        />
        <img
          class="title"
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 395.68 138.99'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23bd802f;%7D.cls-2%7Bfill:%23231815;%7D.cls-3%7Bfill:%230071b6;%7D%3C/style%3E%3C/defs%3E%3Cg id='圖層_2' data-name='圖層 2'%3E%3Cg id='圖層_2-2' data-name='圖層 2'%3E%3Cpath class='cls-1' d='M145.28,41l13,0v3.71l-29.79-.07V41l12.49,0V36.78l-9.06,0V33.15l9.06,0v-4l-7.35,0v-3a44.12,44.12,0,0,1-4.45,2.61,18,18,0,0,0-2.55-3.37,39.66,39.66,0,0,0,11.54-7.56h-4.66V14l12,0A31.76,31.76,0,0,0,160,25a20.81,20.81,0,0,0-2.8,3.81,33.39,33.39,0,0,1-4.41-2.5v2.87l-7.49,0v4l9.17,0v3.6l-9.18,0Zm6.34-15.5a45.73,45.73,0,0,1-8.38-7.68,48.22,48.22,0,0,1-8.63,7.64Z'/%3E%3Cpath class='cls-1' d='M184.4,16.23c3.22,3,7.37,7.34,9.19,10.28L190,29.06a31.84,31.84,0,0,0-1.81-2.67c-18.59.87-21.07.93-22.93,1.56a32.15,32.15,0,0,0-1.36-4,7,7,0,0,0,2.91-2,46.62,46.62,0,0,0,7.45-9.5l4.19,1.79a57.24,57.24,0,0,1-7.65,8.91l14.35-.42c-1.36-1.54-2.75-3-4.05-4.31Zm-18,14,23.59.06,0,15.33h-4.48V43.89l-14.84,0v1.79h-4.27Zm4.26,4v5.6l14.84,0V34.3Z'/%3E%3Cpath class='cls-1' d='M228.08,31.74a21.35,21.35,0,0,1-4.32,8.08,19.49,19.49,0,0,0,6,2.46,14,14,0,0,0-2.46,3.22A19.27,19.27,0,0,1,221,42.4a23.43,23.43,0,0,1-6.14,3.35,14.47,14.47,0,0,0-2.06-3.09v3.12H208.9v-3c-4.06.44-8.12.82-11.27,1.16l-.31-3.57c.91-.07,1.92-.14,3-.24l0-10.61h-2.73V26.21l31.08.07v3.29l-15.92,0,0,12.89a17.64,17.64,0,0,0,5.29-2.65,21.36,21.36,0,0,1-3.35-5.37l1.26-.34h-2.1V30.87l10.92,0,.67-.13Zm-22.31-6.6h-4l0-10.95,23,.05,0,11h-4.2l0-8.09-14.8,0Zm-1.68,14.63c1.54-.14,3.22-.27,4.83-.44V38.1h-4.83Zm0-4.55h4.83v-1.4H204.1Zm0-5.71V31h4.83V29.53Zm15.18-8.75-12.43,0V18.32l12.42,0Zm-12.4,3.72V22.06l12.4,0v2.42Zm11.49,9.58a13.6,13.6,0,0,0,2.37,3.3A13.23,13.23,0,0,0,223,34.07Z'/%3E%3Cpath class='cls-1' d='M245.09,15.89A37.53,37.53,0,0,1,241.83,20c1.95,3.75,2.29,7.75,2.28,11.91,0,4.8-.44,9.42-2.09,11.55a3.81,3.81,0,0,1-2.25,1.43,16.47,16.47,0,0,1-4.83.26A8.25,8.25,0,0,0,233.76,41a26.46,26.46,0,0,0,4,0,1.49,1.49,0,0,0,1.12-.63c.7-1,1-4.2,1.07-8.19a31,31,0,0,1-5.54,5.38,18.86,18.86,0,0,0-2.34-3.54,21.54,21.54,0,0,0,7.54-7.55,17.83,17.83,0,0,0-.9-3.39,43,43,0,0,1-4.56,3.77,17.39,17.39,0,0,0-2.37-3.69,30.25,30.25,0,0,0,5.05-3.66,19,19,0,0,0-3.49-3.68l3-2.3a20,20,0,0,1,3.29,3.19A23.11,23.11,0,0,0,242,13.85Zm19.27,24.62v4l-20.41,0v-4l8.54,0,0-9H246V27.58l6.51,0,0-8h-6.93v-4l18.27.05v3.95h-7l0,8,6.72,0v3.92l-6.72,0,0,9Z'/%3E%3Cpath class='cls-2' d='M296.78.11c-1.49,4.58-3,9.14-4.57,13.71l-4.7,13.66c-1.59,4.55-2.93,9.18-4.85,13.61a112.74,112.74,0,0,1-6.38,13L276,54a111.89,111.89,0,0,1,3.86-14c1.5-4.58,3.57-8.94,5.4-13.39l5.55-13.34c1.9-4.43,3.75-8.88,5.69-13.29Z'/%3E%3Cpath class='cls-2' d='M95.28,0c1.93,4.41,3.79,8.86,5.68,13.29l5.55,13.34c1.83,4.45,3.9,8.81,5.4,13.39a113.67,113.67,0,0,1,3.87,14l-.28.11a112.81,112.81,0,0,1-6.39-13c-1.91-4.43-3.26-9.06-4.85-13.61l-4.7-13.66C98,9.25,96.48,4.69,95,.11Z'/%3E%3Cpath class='cls-3' d='M1.15,124.07c-3.06-8,.28-14.61,6.39-17a10.56,10.56,0,0,1,8.28.38l-1.37,4.05a6.7,6.7,0,0,0-5.22-.32C5.57,112.63,4,116.82,6,122s5.72,7.48,9.54,6a7.21,7.21,0,0,0,4.08-4.3l3.7,2A10.48,10.48,0,0,1,17,132.27C10.9,134.61,4.25,132.14,1.15,124.07Z'/%3E%3Cpath class='cls-3' d='M20.07,103l8.08-2.67c5.45-1.81,10.26-1.3,12.19,4.52,1.86,5.61-1.53,9.54-6.81,11.28l-3.29,1.09L33.13,126l-4.92,1.63Zm11.84,9.36c3.39-1.13,4.55-3.09,3.61-5.92s-3.06-3.23-6.45-2.1l-2.79.92L29,113.34Z'/%3E%3Cpath class='cls-3' d='M51.37,90.74A56.76,56.76,0,0,1,50.09,99l6.11,22.86-3.72,1L48,106c-.4.94-.83,1.89-1.25,2.76a26.05,26.05,0,0,0-3.22-3.63,37.56,37.56,0,0,0,3.93-14.6Zm27.94,20.65.91,3.39-22.76,6.07-.91-3.38,2.91-.78L54.46,98l5.85-1.56c-.06-.75-.13-1.56-.21-2.41L52.42,96l-.92-3.45,8.15-2.18c-.18-1.11-.35-2.12-.53-3.08l4.3-1c.11,1,.16,2,.26,3L72,87.12l.92,3.45-9,2.41c0,.9,0,1.69,0,2.45l7.81-2.09,5,18.74ZM58.79,100l.5,1.86,10-2.67-.49-1.86Zm11.25,2-10,2.68.5,1.86,10-2.68Zm-8.79,7.24.52,1.93,10-2.67-.52-1.93Zm1.76,6.6,10-2.68-.5-1.89-10,2.67Z'/%3E%3Cpath class='cls-3' d='M78.45,86.37l5.18-1.05,10.1,12,3.65,5,.17,0c-.81-2.59-1.87-5.87-2.45-8.75l-2-10.12,4.8-1L103,107.83l-5.15,1L87.76,96.77l-3.68-4.94-.17,0c.8,2.69,1.82,5.81,2.41,8.72l2.05,10.19-4.8,1Z'/%3E%3Cpath class='cls-3' d='M105.77,94.05c-1.23-8.35,2.74-13.88,9.52-14.88s12.18,3.2,13.41,11.51-2.71,14.09-9.5,15.09S107,102.36,105.77,94.05Zm17.7-2.6c-.81-5.51-3.72-8.44-7.53-7.88s-5.75,4.21-4.94,9.71,3.74,8.61,7.55,8S124.27,96.92,123.47,91.45Z'/%3E%3Cpath class='cls-3' d='M134.42,100.38a3.21,3.21,0,1,1,3.53,3A3.22,3.22,0,0,1,134.42,100.38Z'/%3E%3Cpath class='cls-3' d='M145.92,97.86l5.54-.43L150.22,81.1l-4.67.36-.24-3.18a16.62,16.62,0,0,0,5.83-2.62l3.81-.28L156.59,97l4.85-.36.32,4.15L146.23,102Z'/%3E%3Cpath class='cls-3' d='M204.88,80.13v3l-6.33,0-.27,2.73-20.13.1.34-2.73-5.5,0v-3l5.91,0,.34-2.66,19.81-.1-.23,2.66Zm-9.22,18.11c3.08.82,6.17,1.72,8.23,2.37l-2.82,2.57c-2.52-.93-6.63-2.31-10.66-3.34l1.43-1.58-6.41,0,2.11,1.53a43.34,43.34,0,0,1-11.88,3.53,20.22,20.22,0,0,0-2.22-2.83,46,46,0,0,0,9.19-2.22l-5,0L177.57,87l22.82-.12.06,11.34ZM177.71,79.36H174l0-6.09,12.78-.06a17.08,17.08,0,0,0-1-2.1l3.64-1a18.79,18.79,0,0,1,1.62,3.11l12.78-.07,0,6.1h-3.88l0-2.87-22.16.12Zm3.9,10.72L196.17,90V89l-14.56.08Zm0,3.08,14.56-.07V92l-14.56.08Zm0,3.08,14.57-.07V95.05l-14.56.07Zm.5-12.36,4.62,0,.14-1.12-4.62,0Zm.51-4.2-.14,1,4.59,0,.1-1Zm12,4.14.1-1.12-4.48,0-.13,1.12Zm.33-4.2-4.41,0-.06,1,4.41,0Z'/%3E%3Cpath class='cls-3' d='M220.83,95.29l-12.91,2.89-.8-4c1.42-.22,3.16-.57,5.08-.93l.44-7L208.77,86l.24-3.81,3.88.25.39-6.08-4.2-.27.25-3.84,12.23.78-.25,3.84-4-.26-.38,6.08,3.63.24-.25,3.8-3.63-.23-.38,6,4.23-.89Zm15.2,5.85c.63,0,.81-.51,1.1-4a10.78,10.78,0,0,0,3.36,1.76c-.65,4.76-1.64,6-4.23,5.83l-2.62-.17c-3.21-.2-3.84-1.43-3.61-5l.44-6.85-2.13-.14c-1,5.66-2.86,9.61-10.44,11.33a12.43,12.43,0,0,0-2.09-3.57c6.42-1.17,7.72-4,8.44-8l-2.55-.16L223,72.63,240,73.72l-1.25,19.56-4.3-.27L234,99.85c-.06,1,0,1.16.59,1.2ZM225.79,89.05l9.12.58.14-2.16-9.12-.59Zm.34-5.31,9.12.58.14-2.16-9.12-.59Zm.34-5.31,9.12.58.14-2.16-9.12-.59Z'/%3E%3Cpath class='cls-3' d='M244.44,89.08,275,93.18l-.83,6.17-4.09-.55.41-3L257.14,94l2.59.91c-.32.28-.63.52-.94.76l7.39,1,.75-.07,2.4,1.84c-5.09,6.06-14.64,7.5-24.43,7.28a15.89,15.89,0,0,0-1.2-3.73,54.54,54.54,0,0,0,10.6-.27,26,26,0,0,0-2.83-2.82c-.81.17-1.64.31-2.5.44a10.25,10.25,0,0,0-2-3.2c3.92-.29,6.76-1.14,8.55-2.35l-7.6-1-.41,3-3.89-.52ZM255,79.55l-9.33-1.26.46-3.47,9.34,1.26.24-1.81,4.09.55-.87,6.52-4.1-.55Zm-6.58,1.13,25.36,3.4-1,7.6-25.36-3.41Zm3,5.41,3.58.48.3-2.29-3.57-.48Zm3.68,11.83a27.36,27.36,0,0,1,3.06,3A16.18,16.18,0,0,0,262.89,99ZM258.46,87l3.64.49.31-2.29-3.65-.49ZM277,79l-.46,3.43-9.37-1.25L267,82.43l-4.13-.55.88-6.53,4.13.56-.25,1.8Zm-11.49,9,3.75.5.31-2.29-3.75-.5Z'/%3E%3Cpath class='cls-3' d='M276.08,106.18a24.05,24.05,0,0,0,4.45-6.44l3.33,2.19a34.36,34.36,0,0,1-4.42,6.88ZM285.31,93a20,20,0,0,1-4.9,4.17,14.79,14.79,0,0,0-2-3.35,20.77,20.77,0,0,0,7.4-6.44l-5-1,.72-3.46,5.62,1.16,1-4.83L292,80l-1,4.83,4.84,1-.72,3.46-4.83-1-.26,1.26c1.2,1.08,4,4.08,4.63,4.89l-2.8,2.82c-.61-1-1.62-2.52-2.62-3.9l-1.48,7.16-3.87-.8Zm10.46,16.67c1.61.33,2-.1,2.87-3.52a10.15,10.15,0,0,0,3.37,2.2c-1.53,4.8-2.91,5.76-6.68,5l-6.17-1.27c-4.66-1-5.59-2.34-4.85-5.9l1-4.7,4,.83-1,4.63c-.21,1,.1,1.23,1.95,1.62Zm-2.22-9.32.56.76L297.85,83l13.92,2.87L308,104.3l-13.57-2.8c1.08,1.51,2.25,3.25,2.88,4.38l-3.46,1.86a51,51,0,0,0-3.54-5.7ZM298.4,99l6.31,1.31.42-2.06-6.3-1.3Zm1.05-5,6.3,1.3.41-2-6.3-1.3Zm1-5,6.31,1.3.41-2L300.89,87Zm5,15.48c.94,2.41,2.32,5.74,2.88,7.71l-4.21,1.17c-.45-2-1.71-5.39-2.57-8Z'/%3E%3Cpath class='cls-3' d='M335.51,90.49c-.43,1.41-1,3.21-1.71,5.19-.81,4.68-2.33,18,8,26.45a11.09,11.09,0,0,0-3.91,2.65c-6.47-5.68-8.36-13.3-8.69-19.64-3.52,5.4-8.77,10.51-16.93,12.64a13.59,13.59,0,0,0-2.42-4.2c15.73-3.46,19.34-18.73,21.08-24.39Z'/%3E%3Cpath class='cls-3' d='M374,132.4l-1.38,3.86L343,125.61l1.39-3.85,12.71,4.57,2.38-6.62-8.93-3.21,1.37-3.79,8.92,3.21,2.09-5.8-6.82-2.45a29.23,29.23,0,0,1-4.78,3.68,33.41,33.41,0,0,0-2.69-3.61c3.57-1.84,7.34-5.62,10.07-9.7l3.73,2.35c-1,1.41-2.11,2.77-3.21,4.09l5.07,1.82,2.13-5.93,4.12,1.48-2.13,5.93,11.1,4-1.37,3.82-11.11-4L365,117.4l9.85,3.54-1.36,3.79-9.85-3.54-2.38,6.62Z'/%3E%3Cpath class='cls-3' d='M380.42,134.09a3.64,3.64,0,0,1,6.71,2.82,3.65,3.65,0,0,1-6.71-2.82Zm7.46-16.23,1.9-4.86,5.9,2.48-2.18,4.74-5.77,10.56-3.32-1.4Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
          alt=""
          srcset=""
        />
      </div>
      <p
        class="content"
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-delay="400"
      >
        買房最好的時機，相較頭城、礁溪房價高點，<br />
        『The Taurus 金牛座』精質坪數換超星級豐富休閒渡假設施，<br v-if="!isMobile"/>
        全台唯一冷泉溫泉度假宅 為心愛的家人購置第二個家！
      </p>
    </div>
    <div class="bg"></div>
  </div>
</template>
<style lang="scss" scoped>
/* 螢幕尺寸標準 */
.section7 {
  height: auto;

  .title-box {
    position: relative;
    margin-bottom: -11.5vw;
    .img {
      display: flex;
      align-items: center;
      justify-content: center;
      
      .title {
        width: 23vw;
      }
    }
    .tree {
        width: 4vw;
        position: absolute;
        left: 35%;
      }
    .content {
      margin-top: 5vw;
      color: #4d4d4d;
      font-size: 1vw;
      line-height: 1.8vw;
    }
  }
  .bg {
    height: 0;
    width: 100%;
    padding-bottom: 38.26%;
    background-image: url("./s7/bg.png");
    background-size: cover;
  }
}
/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .section7 {
    height: auto;

    .title-box {
      position: relative;
      margin-bottom: 12px;
      .img {
        flex-direction: row-reverse;
        align-items: flex-start;
        .tree {
          width: 10vw;
          position: absolute;
          right: 18vw;
          left: auto;
        }
        .title {
          width: 61vw;
        }
      }
      .content {
        margin-top: 20px;
        color: #4d4d4d;
        font-size: 16px;
        line-height: 2;
        padding: 0 10px;
      }
    }
    .bg {
      height: 0;
      width: 100%;
      padding-bottom: 50%;
      background-image: url("./s7/bg.png");
      background-size: cover;
    }
  }
}

// 避免內容電腦過渡平板時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1199.98px) {
}

// 避免過度到 1280 x 720 時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
}
</style>

<script>
// @ is an alias to /src
import { isMobile } from "@/utils";
export default {
  name: "section7",

  data() {
    return {
      isMobile,
    };
  },

  methods: {},

  created() {},
};
</script>
